import { Injectable } from '@angular/core';
import { surveysConfig } from '../../surveys-config';

/**
 * Service centralizing access to survey configuration.
 * Provides easy access to year parameters, survey IDs and helper methods.
 */
@Injectable({
  providedIn: 'root'
})
export class SurveyConfigService {

  // Years
  get currentYear(): number {
    return surveysConfig.currentYear;
  }

  get previousYear(): number {
    return surveysConfig.previousYear;
  }

  // Survey IDs
  get currentYearSurveyId(): number {
    return surveysConfig.currentYearSurveyId;
  }

  get previousYearSurveyId(): number {
    return surveysConfig.previousYearSurveyId;
  }

  /**
   * Checks if the given surveyId is for the current year survey
   */
  isCurrentYearSurvey(surveyId: number): boolean {
    return surveyId === this.currentYearSurveyId;
  }

  /**
   * Checks if the given surveyId is for the previous year survey
   */
  isPreviousYearSurvey(surveyId: number): boolean {
    return surveyId === this.previousYearSurveyId;
  }
}
